// assets
import { User, Calendar, ReceiptText, Shop, ChartSquare, DocumentText } from 'iconsax-react';
import DashboardSvgIcon from '@/assets/svgs/DashboardSvgIcon';

// type
import { NavItemType } from '@/types/bs-types/menu';
import ReportFileSvgIcon from '@/assets/svgs/ReportFileSvgIcon';
import UsersSvgIcon from '@/assets/svgs/UsersSvgIcon';
import PurchaseSvgIcon from '@/assets/svgs/PurchaseSvgIcon';
import ProductionSvgIcon from '@/assets/svgs/ProductionSvgIcon';
import PeriodSvgIcon from '@/assets/svgs/PeriodSvgIcon';
import PaymentSvgIcon from '@/assets/svgs/PaymentSvgIcon';
import PriceSvgIcon from '@/assets/svgs/PriceSvgIcon';

// icons
const icons = {
  dashboard: DashboardSvgIcon,
  user: UsersSvgIcon,
  period: PeriodSvgIcon,
  purchaseOrder: PurchaseSvgIcon,
  production: Shop,
  process: ProductionSvgIcon,
  report: ChartSquare,
  payment: PaymentSvgIcon,
  reportDaily: ReportFileSvgIcon,
  price: PriceSvgIcon
};

// ==============================|| MENU ITEMS - ADMINS ||============================== //
// รายการ url path ทั้งหมดจะเป็น allowAdmins List สำหรับการอนุญาติในการเข้าถึง url path จากหน้านี้

const rootPath = '/admin';

const admins: NavItemType = {
  id: 'group-admin',
  title: 'จัดการ',
  icon: icons.dashboard,
  type: 'group',
  children: [
    {
      id: 'admin-dashboard',
      title: 'แดชบอร์ด',
      type: 'item',
      url: `${rootPath}/dashboard`,
      icon: icons.dashboard
    },
    {
      id: 'admin-users',
      title: 'จัดการสมาชิก',
      type: 'item',
      url: `${rootPath}/users`,
      icon: icons.user
    },
    {
      id: 'admin-latex-price-setting',
      title: 'จัดการราคากลาง',
      type: 'item',
      url: `${rootPath}/latex-price-setting`,
      icon: icons.price
    },

    {
      id: 'admin-latex-period',
      title: 'จัดการงวด',
      type: 'item',
      url: `${rootPath}/latex-period`,
      icon: icons.period
    },
    {
      id: 'admin-latex-purchase-order',
      title: 'รับซื้อน้ำยาง',
      type: 'item',
      url: `${rootPath}/latex-purchase-order`,
      icon: icons.purchaseOrder
    },
    {
      id: 'admin-latex-daily-batch',
      title: 'การผลิต',
      type: 'item',
      url: `${rootPath}/latex-daily-batch`,
      icon: icons.process
    },
    {
      id: 'admin-payment',
      title: 'จ่ายเงิน',
      type: 'item',
      url: `${rootPath}/latex-payment`,
      icon: icons.payment
    },
    {
      id: 'admin-reports',
      title: 'รายงาน',
      icon: icons.reportDaily,
      type: 'collapse',
      children: [
        {
          id: 'admin-report-customer-summary',
          title: 'รายงานซื้อน้ำยางสดรายคน',
          type: 'item',
          url: `${rootPath}/customer-summary`,
          icon: icons.reportDaily,
          breadcrumbs: true
        },
        {
          id: 'admin-report-purchase-summary-all',
          title: 'รายงานรวมรับซื้อน้ำยางสด',
          type: 'item',
          url: `${rootPath}/purchase-summary-all`,
          icon: icons.reportDaily,
          breadcrumbs: true
        },
        {
          id: 'admin-report-profit-summary',
          title: 'รายงานการปันผลสมาชิก',
          type: 'item',
          url: `${rootPath}/profit-summary`,
          icon: icons.reportDaily,
          breadcrumbs: true
        }
      ]
    }
  ]
};

export { admins };
